import { render } from "./LarabergEditor.vue?vue&type=template&id=7f7da32d"
import script from "./LarabergEditor.vue?vue&type=script&lang=js"
export * from "./LarabergEditor.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/e/med/Project/primitive/whouse-disperindag/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__